import React                             from 'react';
import PropTypes                         from 'prop-types';
import Flux                              from '../../../../flux/Flux';
import DailybonusVipOfferDescr           from './DailybonusDescription/DailybonusVipOfferDescr';
import DailybonusPhotoVideoOfferDescr    from './DailybonusDescription/DailybonusPhotoVideoOfferDescr';
import DailybonusTopUpDescr              from './DailybonusDescription/DailybonusTopUpDescr';
import DailybonusMerchOfferDescr         from './DailybonusDescription/DailybonusMerchOfferDescr';
import DailybonusMsgGiftOfferDescr       from './DailybonusDescription/DailybonusMsgGiftOfferDescr';
import DailyBonusVideoVoucherDescription from './DailybonusDescription/DailybonusVideoVoucherDescription';

const {offers} = Flux.Constants.DailyBonuses;

class ItemDescription extends React.Component {

	shouldComponentUpdate(nextProps) {
		return nextProps.bonusOffer.date !== this.props.bonusOffer.date || nextProps.bonusOffer.purchased !== this.props.bonusOffer.purchased;
	}

	render() {
		const {bonusOffer} = this.props;
		switch (bonusOffer.offer) {
			case offers.VIP:
				return <DailybonusVipOfferDescr />;
			case offers.VIDEO:
			case offers.PHOTO_ALBUM:
				return <DailybonusPhotoVideoOfferDescr {...bonusOffer} />;
			case offers.TOP_UP_PERCENT:
			case offers.TOP_UP_FLAT:
				return <DailybonusTopUpDescr {...bonusOffer} />;
			case offers.MERCHANDISE:
				return <DailybonusMerchOfferDescr {...bonusOffer} />;
			case offers.MESSENGER_GIFT:
				return <DailybonusMsgGiftOfferDescr {...bonusOffer} />;
			case offers.VIDEO_VOUCHER:
				return <DailyBonusVideoVoucherDescription conditions={bonusOffer.conditions} />;
			default:
				return null;
		}
	}
}

ItemDescription.propTypes = {
	bonusOffer: PropTypes.shape({
		date:       PropTypes.string,
		offer:      PropTypes.string,
		conditions: PropTypes.array,
		effect:     PropTypes.object,
		quantity:   PropTypes.number,
		content:    PropTypes.object,
		purchased:  PropTypes.bool,
		free:       PropTypes.bool,
	}).isRequired,
};

export default ItemDescription;
